<app-section-wrapper-container>
	<div class="justify-start flex gap-4">
		@for (item of options(); track item.title) {
			@if (!item.hidden) {
				<button
					focus
					active
					[disabled]="item.disabled"
					(click)="item.function()"
					class="max-w-1/2"
					[class]="!item.disabled ? 'cursor-pointer hover-layer' : ''"
					ultra-action-button>
					<app-ultra-icon [svgIcon]="item.icon" />
					<p class="text-sm">{{ item.title | transloco }}</p>
				</button>
			}
		}
	</div>
</app-section-wrapper-container>
